import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Container, Row } from 'react-bootstrap';
import Tabs from '../../components/Tabs/Tabs';
import Contacts from '../widgets/resources/tabs/contactsContent';
import Documents from '../widgets/resources/tabs/documentsContent';
import FAQs from '../widgets/resources/tabs/FAQsContent';

import Tools from '../widgets/resources/tabs/toolsContent';

const tabsData = [
  {
    name: 'Tools',
    content: <Tools />,
    leftIcon: <FontAwesomeIcon icon={light('screwdriver-wrench')} />,
    href: '#/resources/tools',
  },
  {
    name: 'Info/Forms',
    content: <Documents />,
    leftIcon: <FontAwesomeIcon icon={light('file')} />,
    href: '#/resources/documents',
  },
  {
    name: 'FAQs',
    content: <FAQs />,
    leftIcon: <FontAwesomeIcon icon={light('comments-question-check')} />,
    href: '#/resources/faqs',
  },
  {
    name: 'Contacts',
    content: <Contacts />,
    leftIcon: <FontAwesomeIcon icon={light('address-book')} />,
    href: '#/resources/contacts',
  },
];

function Resources() {
  return (
    <Container className="cnd-custom-container my-12 px-0 container">
      <Container>
        <Row lg={2} sm={1}>
          <Col className={'col-lg-7'}>
            <Container className={'px-0'}>
              <div className={'p-0'}>
                <h3 className={'mb-lg-7 mb-md-5 text-sm-20-lg-48'}>
                  Resources
                </h3>
                <div className={'fw-light lh-xs text-sm-12-lg-14'}>
                  <p>
                    In this section you'll have access to various tools,
                    information, Forms, FAQs, and benefit contact information.
                  </p>
                </div>
              </div>
            </Container>
          </Col>
          <Col className={'col-lg-5'}>
            <Container className={'px-0 my-lg-10'}>
              <img
                className={'d-block mx-auto'}
                style={{ width: '287px', height: '196px' }}
                alt={'rcs'}
                src={`${process.env.PUBLIC_URL}/${'folder-search.png'}`}
              ></img>
            </Container>
          </Col>
        </Row>
      </Container>
      <Container className={'px-0'}>
        <Tabs tabs={tabsData} variant={'horizontal'}></Tabs>
      </Container>
    </Container>
  );
}

export default Resources;
